import React, { useState } from "react";

export const Deliveries = (props) => {
  const [selected, setSelected] = useState(null);

  return (
    <section id="deliveries" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Deliveries</h2>
          <p>
            We have delivered multiple projects to our clients and are working
            on exciting new ones.
          </p>
        </div>

        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className="col-md-4">
                  
                  {/* CARD */}
                  <div
                    className="delivery-card"
                    onClick={() => setSelected(d)}
                  >
                    <i className={d.icon}></i>
                    <h3>{d.title}</h3>
                    <p>{d.text}</p>

                    <button
                      className="view-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        window.open(d.link, "_blank");
                      }}
                    >
                      View Project
                    </button>
                  </div>

                </div>
              ))
            : "Loading..."}
        </div>

        {/* MODAL */}
        {selected && (
          <div className="custom-modal" onClick={() => setSelected(null)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <h2>{selected.title}</h2>
              <p>{selected.text}</p>
              <button
                onClick={() => window.open(selected.link, "_blank")}
              >
                Open Project
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};